module.exports = __webpack_public_path__ + "static/media/50_B.33ff10c9.png";